import React from "react";
import { useIntl } from "react-intl";

const SectionGuard = ({
  hasContent,
  isLoading = false,
  showEmpty = true,
  emptyMessageId = "empty.section",
  emptyMessage = "",
  className = "",
  children,
}) => {
  const intl = useIntl();

  if (isLoading) {
    return null;
  }

  if (hasContent) {
    return <>{children}</>;
  }

  if (!showEmpty) {
    return null;
  }

  const message = emptyMessage || intl.formatMessage({ id: emptyMessageId });

  return (
    <div className={`py-8 text-center text-gray-500 ${className}`}>{message}</div>
  );
};

export default SectionGuard;
